import { render, staticRenderFns } from "./FeedSupplementList.vue?vue&type=template&id=4bca1de8&scoped=true&"
import script from "./FeedSupplementList.vue?vue&type=script&lang=js&"
export * from "./FeedSupplementList.vue?vue&type=script&lang=js&"
import style0 from "./FeedSupplementList.vue?vue&type=style&index=0&id=4bca1de8&lang=scss&scoped=true&"
import style1 from "./FeedSupplementList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bca1de8",
  null
  
)

export default component.exports